import env from '@common/env';

export const isNextAuthEnabled = !!env('OKTA_OAUTH2_LOGOUT_REDIRECT_URI');
